import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const setupI18n = (multiLanguage?: any) => {
  if(!multiLanguage){
  return  i18n
    .use(initReactI18next) // Pass to react-i18next
    .use(Backend) // Load translations from external files
    .use(LanguageDetector) // Detect language from browser
    .init({
      backend: {
        loadPath: '/locales/{{lng}}/translation.json',
      },
      fallbackLng: 'en', // Default language
      debug: true,
      interpolation: {
        escapeValue: false, // React already escapes values
      },
    });
  }
  console.log("afffffffffffffff");
  
  i18n
    .use(initReactI18next) // Pass to react-i18next
    .use(Backend) // Load translations from external files
    .use(LanguageDetector) // Detect language from browser
    .init({
      // backend: {
      //   loadPath: '/locales/{{lng}}/translation.json',
      // },
      fallbackLng: 'en', // Default language
      debug: true,
      interpolation: {
        escapeValue: false, // React already escapes values
      },
    });

  // Assuming `multiLanguage` is structured as { en: { key: 'value' }, es: { key: 'value' }, ... }
  if (multiLanguage && multiLanguage.length > 0) {
    multiLanguage.forEach((lan:any) => {
      i18n.addResourceBundle(lan.language_code, 'translation', lan.content, true, true);
    });
  }
};
export {i18n}
export default setupI18n;
